.plan-comparison {
    width: 100%;
    min-width: fit-content;
    box-sizing: border-box;
    padding: 16px;
    border: 1px solid var(--off-white-dk);
    border-radius: 3px;
}
